import DesktopWindowsOutlined from '@mui/icons-material/DesktopWindowsOutlined';
import HearingOutlined from '@mui/icons-material/HearingOutlined';
import LocalFireDepartmentOutlined from '@mui/icons-material/LocalFireDepartmentOutlined';
import MedicalServicesOutlined from '@mui/icons-material/MedicalServicesOutlined';
import NotificationsActiveOutlined from '@mui/icons-material/NotificationsActiveOutlined';
import NotificationsNoneOutlined from '@mui/icons-material/NotificationsNoneOutlined';
import SecurityRounded from '@mui/icons-material/SecurityRounded';
import Constants from 'style/constants';
import { AlarmType } from 'shared/components/alarm-card/enums/alarm-type';
import ConnectionIcon from 'shared/components/icons/connection-icon';
import Custom1Icon from 'shared/components/icons/custom1-icon';
import Custom2Icon from 'shared/components/icons/custom2-icon';
import Custom3Icon from 'shared/components/icons/custom3-icon';
import DoorOpenOutlineRoundedIcon from 'shared/components/icons/door-open-outline-rounded-icon';
import Doorbell3POutlineIcon from 'shared/components/icons/doorbell-3p-outline-icon';
import EmergencyHomeRounded from 'shared/components/icons/emergency-home-rounded';
import GearIcon from 'shared/components/icons/gear-icon';
import { InBathroomIcon } from 'shared/components/icons/in-bathroom-icon';
import IntentionOutOfBedIcon from 'shared/components/icons/intention-out-of-bed-icon';
import IntruderIcon from 'shared/components/icons/intruder-icon';
import MotionDetectedIcon from 'shared/components/icons/motion-detected-icon';
import OutOfBedIcon from 'shared/components/icons/out-of-bed-icon';
import { OutOfRoomIcon } from 'shared/components/icons/out-of-room-icon';
import { PassageBlockedIcon } from 'shared/components/icons/passage-blocked-icon';
import SolidPeopleRobberyIcon from 'shared/components/icons/solid-people-robbery-icon';
import SolidPersonFallingIcon from 'shared/components/icons/solid-person-falling-icon';
import SolidPersonWalkingDashedLineArrowRightIcon from 'shared/components/icons/solid-person-walking-dashed-line-arrow-right-icon';
import SupervisorAccountOutlinedIcon from 'shared/components/icons/supervisor-account-outlined-icon';

type Props = {
  type: AlarmType;
};

const AlarmIcon = ({ type }: Readonly<Props>): React.JSX.Element => {
  switch (type) {
    case AlarmType.Acoustic:
      return <HearingOutlined />;
    case AlarmType.Call:
    case AlarmType.ToiletCall:
    case AlarmType.BroadcastCall:
    case AlarmType.WirelessCall:
    case AlarmType.GenericCall:
      return <NotificationsNoneOutlined />;
    case AlarmType.Assistance:
      return <SupervisorAccountOutlinedIcon />;
    case AlarmType.Doctor:
      return <MedicalServicesOutlined />;
    case AlarmType.Door:
    case AlarmType.DoorOpen:
      return <DoorOpenOutlineRoundedIcon />;
    case AlarmType.Doorbell:
      return <Doorbell3POutlineIcon />;
    case AlarmType.Emergency:
      return <EmergencyHomeRounded />;
    case AlarmType.EmergencyCall:
      return <NotificationsActiveOutlined />;
    case AlarmType.ExternalSystem:
      return <DesktopWindowsOutlined />;
    case AlarmType.IntruderDetected:
      return <IntruderIcon color={Constants.Colors.onSurface} />;
    case AlarmType.Fall:
      return <SolidPersonFallingIcon color={Constants.Colors.onSurface} />;
    case AlarmType.Fire:
      return <LocalFireDepartmentOutlined />;
    case AlarmType.Medical:
      return <Custom1Icon color={Constants.Colors.onSurface} />;
    case AlarmType.Movement:
      return <MotionDetectedIcon />;
    case AlarmType.IntentionOutOfBed:
      return <IntentionOutOfBedIcon color={Constants.Colors.onSurface} />;
    case AlarmType.OutOfBed:
      return <OutOfBedIcon color={Constants.Colors.onSurface} />;
    case AlarmType.OutOfRoom:
      return <OutOfRoomIcon color={Constants.Colors.onSurface} />;
    case AlarmType.InBathroom:
      return <InBathroomIcon color={Constants.Colors.onSurface} />;
    case AlarmType.PersonalSecurity:
      return <SecurityRounded />;
    case AlarmType.PullOut:
      return <ConnectionIcon />;
    case AlarmType.Resuscitation:
      return <Custom2Icon />;
    case AlarmType.Robbery:
      return <SolidPeopleRobberyIcon />;
    case AlarmType.ServiceRequest:
      return <Custom3Icon />;
    case AlarmType.Technical:
      return <GearIcon color={Constants.Colors.onSurface} />;
    case AlarmType.WanderingDetection:
      return <SolidPersonWalkingDashedLineArrowRightIcon color={Constants.Colors.onSurface} />;
    case AlarmType.EmergencyAlarm:
      return <SecurityRounded />;
    case AlarmType.PassageBlocked:
      return <PassageBlockedIcon color={Constants.Colors.onSurface} />;
    default:
      return <></>;
  }
};

export default AlarmIcon;
